// @flow

import * as React from 'react';
import classNames from 'classnames';
import Box from 'sail/Box';
import Notice from 'sail/Notice';
import './InfoBoxWithCallout.scss';

type InfoBoxWithCalloutProps = {|
  className?: string,
  children?: React.Node,
  callout: string,
  icon?: string,
|};

export const InfoBoxWithCallout = ({
  className,
  children,
  callout,
  icon,
}: InfoBoxWithCalloutProps) => {
  return (
    <header className={classNames('InfoBoxWithCallout', className)}>
      {children}
      <Box className="InfoBoxWithCalloutAside">
        {/* $FlowExpectedError icon wants a specific string but we just have a generic one */}
        <Notice description={callout} divider icon={icon} color="offset" />
      </Box>
    </header>
  );
};
